module.exports = {
	"payments": {
		"attributes": {
			"invoice": "Fatura",
			"split_number": "Opções de parcelamento",
			"amount_due": "Total",
			"banks": "Bancos",
			"card": {
				"number": "Número do cartão",
				"name": "Nome impresso",
				"cvv": "Código de verificação",
				"expiration_date": "Data de validade (Mês/Ano)",
				"brand": "Bandeira"
			}
		},
		"methods": {
			"select_method": "Selecione a forma de pagamento",
			"billet": "Boleto bancário",
			"card": "Cartão de crédito",
			"transfer": "Transferência",
			"yapay_balance": "Saldo Vindi"
		},
		"messages": {
			"change_method": "Alterar forma de pagamento",
			"finalize_payment": "Finalizar pagamento",
			"finalized_payment": "Pagamento Finalizado",
			"successful_payment": "Seu pagamento foi recebido com sucesso!",
			"approved_by_card": "A <strong class=\"ls-color-theme\">confirmação do pagamento será realizada de forma automática</strong> assim que identificarmos a aprovação do pagamento realizado.",
			"approved_by_yapay": "A <strong class=\"ls-color-theme\">confirmação do pagamento será realizada de forma automática</strong> assim que identificarmos a aprovação do pagamento realizado.",
			"you_will_receive_the_billet_monthly": "Um novo link de pagamento será enviado <strong class=\"ls-color-theme\">mensalmente</strong> ao seu e-mail, após a confirmação do pagamento.",
			"expired_invoice": "A fatura está vencida!",
			"invoice_canceled": "A fatura está cancelada.",
			"invoice_refunded": "A fatura já foi extornada.",
			"invoice_paid": "O pagamento de sua fatura já foi realizado e confirmado.",
			"invoice_awaiting_approval": "O pagamento desta fatura já foi realizado, estamos aguardando aprovação do meio de pagamento utilizado",
			"invoice_partially_paid": "Esta fatura ja possui um pagamento parcial.",
			"invalid_invoice": "Fatura não encontrada.",
			"ticket_generated": "Seu boleto foi gerado com sucesso!",
			"none_configured_payment_methods": "Nenhum meio de pagamento configurado.",
			"insufficient_funds": "Não será possível realizar o pagamento pois seu saldo é insuficiente",
			"account_verification_wiki": "Para finalizar o pagamento, verifique sua conta Yapay. Saiba mais em <a target=\"_blank\" href=\"https://atendimento.yapay.com.br/hc/pt-br/articles/360006545293-O-que-%C3%A9-verifica%C3%A7%C3%A3o-de-conta-e-como-funciona-\">O que é verificação de conta e como funciona?</a>"
		},
		"labels": {
			"yapay_account": "Conta Yapay",
			"do_login_to_continue": "Para continuar é necessário identificar-se",
			"recurring_card": "Desejo utilizar o cartão selecionado para pagamento automático das próximas faturas.",
			"recurring_balance": "Desejo utilizar meu saldo Yapay para pagamento automático das próximas faturas.",
			"payment_details": "Detalhes do pagamento",
			"available_balance": "Saldo disponível",
			"available_balance_after_payment": "Saldo após confirmar o pagamento",
			"insufficient_balance": "Saldo insuficiente para realizar o pagamento",
			"select_brand_to_show_split": "Selecione a bandeira do cartão para ver as opções de parcelamento"
		},
		"buttons": {
			"change_account": "Alterar conta",
			"pay": "Pagar"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/payments/pt-BR.yml
// module id = 587
// module chunks = 1